import { combineReducers } from "redux";
import { LoginUserReducers } from "../Reducers/LoginReducers";
import {
  DeactivateHoldReducers,
  DownloadBoxLabelReducers,
  GetSkuProductsReducers,
  GetUserProfileReducers,
  HourlyProductionReportReducers,
  ManufacturingPackingDropdownDataReducers,
  MarkHoldReducers,
  PortalNetInventoryPopupReducers,
  ProductLevelConsolidatedReportReducers,
  ProductSubGroupMasterDataReducers,
  RunCronFunctionReducers,
  SaveGetBoxSettingsReducers,
  SaveGetBoxTypeReducers,
  closeBoxReducers,
  createBoxReducers,
  createMRPLabelReducers,
  getBatchDetailsReducers,
  getBatchesReducers,
  getInventoryDetailsReducers,
  getMissingInventoryListReducers,
  getPortalNetInventoryReducers,
  getProductListReducers,
  getSalesAnalysisDetailsReducers,
  getSalesAnalysisListReducers,
  getSubOrderLevelViewReducers,
  getSubOrderSummaryReducers,
  getsuborderPortalNetCSVReducers,
  saveTempHoldReducers,
  scanSerialBoxReducers,
  undoScannableIncomingReducers,
  viewPreviousBoxReducers,
} from "../Reducers/ProductionReducers";
import {
  ChangeInspectionStatusReducers,
  CreateChallanReducers,
  CreateNewSerialCodeReducers,
  deleteChallanReducers,
  EvaluateDefectReducers,
  GetBasicQualityReducers,
  getChallanReducers,
  GetMediaReducers,
  getSettingsReducers,
  ListInspectionPointReducers,
  saveInspectionPointReducers,
  saveSettingsReducers,
  ViewDetailsReducers,
} from "../Reducers/AuditReducers";

const rootReducer = combineReducers({
  // COMMON REDUCERS
  login: LoginUserReducers,

  // PRODUCTION MODULE REDUCERS
  manufacturingDropdown: ManufacturingPackingDropdownDataReducers,
  InventoryShow: getInventoryDetailsReducers,
  ShowPreviousBox: viewPreviousBoxReducers,
  scanSerialBoxes: scanSerialBoxReducers,
  MRPLabelPdf: createMRPLabelReducers,
  ClosingBox: closeBoxReducers,
  createBox: createBoxReducers,
  boxLabel: DownloadBoxLabelReducers,
  products: GetSkuProductsReducers,
  userProfile: GetUserProfileReducers,
  productsList: getProductListReducers,

  // QUALITY MODULE REDUCERS
  basicQuality: GetBasicQualityReducers,
  Media: GetMediaReducers,
  QualityDetails: ViewDetailsReducers,
  SettingsData: getSettingsReducers,
  SaveSettings: saveSettingsReducers,
  ListInspectionRandomScan: ListInspectionPointReducers,
  saveInspectionPoint: saveInspectionPointReducers,
  changeInspectionStatus: ChangeInspectionStatusReducers,
  EvalDefects: EvaluateDefectReducers,
  NewSerialCodes: CreateNewSerialCodeReducers,
  SaveChallan: CreateChallanReducers,
  get_Challan: getChallanReducers,
  DeleteChallan: deleteChallanReducers,
  SaveGetBoxType: SaveGetBoxTypeReducers,
  SaveGetBoxSetting: SaveGetBoxSettingsReducers,
  ProductSubGroup: ProductSubGroupMasterDataReducers,
  ScannableUndoIncoming: undoScannableIncomingReducers,

  // New Module
  Batches: getBatchesReducers,
  BatchDetails: getBatchDetailsReducers,
  MarkHold: MarkHoldReducers,
  ProductLevelConsolidatedReport: ProductLevelConsolidatedReportReducers,
  HourlyProductionReport: HourlyProductionReportReducers,
  subOrderSummary: getSubOrderSummaryReducers,
  SaveTempHoldInventory: saveTempHoldReducers,
  DeactivateHoldTemp: DeactivateHoldReducers,
  PortalAvailableInven: getPortalNetInventoryReducers,
  SubOrderLevelViewConsol: getSubOrderLevelViewReducers,
  SalesAnalysisList: getSalesAnalysisListReducers,
  SalesAnalysisDetails: getSalesAnalysisDetailsReducers,
  MissingInventoryList: getMissingInventoryListReducers,
  PortalNetInventoryPopup: PortalNetInventoryPopupReducers,
  RunCronJobs: RunCronFunctionReducers,
});

export default rootReducer;
